export const isOcrRoot = (loginName: unknown) => loginName === 'root'
